<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Statements</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Statements</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header" v-if="true">
            <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
              class="fa fa-filter"></i>Filter</a>
            <div class="card-tools">
<!--              <router-link :to="{name: 'StatementAdd'}" class="btn btn-success">
                <i class="fas fa-plus"></i> New
              </router-link>-->
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getStatements" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
<!--                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="name" v-model="filter.name" placeholder="Name">
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="mobile_no">Mobile No</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="mobile_no" v-model="filter.mobile_no"
                             placeholder="Mobile No">
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="email">Email</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control" id="email" v-model="filter.email" placeholder="Email">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="organization">Organization</label>
                    <div class="col-md-9">
                      <multiselect
                        id="organization"
                        v-model="filter.organization_id"
                        :options="pre.organizations.map(org => org.id)"
                        :custom-label="opt => pre.organizations.find(x => x.id == opt).org_name"
                        placeholder="Pick Organization" :searchable="true" :multiple="false"
                        class="email"
                      >
                      </multiselect>
                    </div>
                  </div>-->
                  <!-- Date range -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at">Date range</label>
                    <div class="col-md-9">
                      <date-picker type="datetime" input-class="form-control" v-model="filter.created_at" range
                                   lang="en" format="YYYY-MM-DD hh:mm:ss" confirm id="created_at"
                                   value-type="YYYY-MM-DD hh:mm:ss"></date-picker>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i> Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th style="width: 10px">Transaction Id </th>
                  <th>Transaction Activity Type Id</th>
                  <th>Transaction Amount </th>
                  <th>Transaction Type </th>
                  <th>Transaction Note </th>
                  <th>Balance </th>
                </tr>
                </thead>
                <tbody class="users-list">
                <tr v-for="(val, index) in list.data">
                  <td>{{ val.trx_uuid }}</td>
                  <td>{{ val.trx_activity_type_id }}</td>
                  <td>{{ val.trx_amount }}</td>
                  <td>{{ val.trx_type }}</td>
                  <td>{{ val.trx_note }}</td>
                  <td>{{ val.balance }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getStatements()"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>

import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {CommonAPI} from "@/services/api";
const fileDownload = require('js-file-download')
import { Notification } from "element-ui";
import moment from 'moment'

export default {
  name: 'StatementList',
  metaInfo: {
    title: 'Statement List | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {
      created_at: [moment().subtract(1, 'month').format('YYYY-MM-DD hh:mm:ss'), moment().format('YYYY-MM-DD hh:mm:ss')]
    },
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click');
    }
    this.api_url = '/get-transaction-history';
    this.getStatements();
  },
  methods: {
    exportFile: function () {
      this.is_loading = true;
      console.log('exportFile');
      // axios.get('/admin-users-export', {responseType: 'blob'})
      //   .then(response => {
      //     //console.log(response.data);
      //     fileDownload(response.data, 'admin-users.xlsx');
      //   })
      //   .catch((error) => {
      //     console.log("error " + error);
      //   })
      //   .finally(() => {
      //     this.is_loading = false;
      //     Notification.success({title: "Export Completed", message: "Export operation completed successfully", type: "success"});
      //   });
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss');
    },
    getStatements() {
      this.is_loading = true;
      console.log('filter: ', this.filter)
      // let query = {...this.filter, ...this.$route.query}
      let query = {
        "pin": 123456,
        "start_date_time": this.filter.created_at[0],
        "end_date_time": this.filter.created_at[1]
      }
      this.apiStatements(query).then(list => {
        console.log('list', list);
        this.list = list;
        // this.list = sampleData;
      }).finally(() => {
        this.is_loading = false;
      });
    },
    apiStatements(query = null) {
      console.log('query', query);
      return new Promise((resolve, reject) => {
        axios.post(this.api_url, {
          params: query
        }).then(response => {
          console.log('response', response);
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if(Object.keys(query).length > 0) {
        delete query.order_by
        delete query.order_key
        delete query.page
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getStatements();
    },
  }
}
</script>

